import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import OrderDetailWrap from '../../views/order/detail/OrderDetailWrap';
import { orderActions } from '../../store/modules/order';
import { PAY_METHOD_TYPE } from '../../constants/service/app/orderConstants';
import {
  ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL,
} from '../../store/modules/account/user/models';
import { CS_INQUIRY_LIST_SORT_OPTION_MODEL } from '../../store/modules/cs/inquiry/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { CS_QNA_LIST_SORT_OPTION_MODEL } from '../../store/modules/cs/qna/models';

export const initOrderDetailListOption = {
  inquiryHistory: {
    filterOption: ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL,
    sortOption: CS_INQUIRY_LIST_SORT_OPTION_MODEL,
    pagination: LIST_PAGINATION_MODEL,
  },
  qnaHistory: {
    filterOption: ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL,
    sortOption: CS_QNA_LIST_SORT_OPTION_MODEL,
    pagination: LIST_PAGINATION_MODEL,
  },
};

class OrderDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  initiate = (orderItemId) => {
    const { getOrderDetailList } = this.props;
    getOrderDetailList({
      orderItemId,
      ...initOrderDetailListOption,
    });
  };

  /**
   *  교환/반품 요청하기
   */
  requestExchangeReturn = () => {
    const { orderDetail, toggleModal, getPreparationOrderReturnRequest } = this.props;
    const { orderId, orderItemId, orderItemStatus, payMethod } = orderDetail.orderInfo;
    const data = { orderItemId, orderItemStatus };

    /**
     *  가상 계좌인 경우
     */
    if (payMethod === PAY_METHOD_TYPE.VBANK) {
      getPreparationOrderReturnRequest({
        orderId,
        data,
      });
    } else {
      toggleModal({
        name: 'orderItemReturnExchangeRequestModal',
        data,
      });
    }
  };

  /**
   *  1:1 문의 리스트 가져오기
   */
  getOrderItemCsInquiryList = (data) => {
    const { getOrderItemCsInquiryList, orderDetail } = this.props;
    const { orderItemId } = orderDetail.orderInfo;
    const { filterOption, sortOption, pagination } = orderDetail.inquiryInfo;

    getOrderItemCsInquiryList({
      orderItemId,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   *  1:1 문의 리스트 엑셀 다운로드
   */
  getOrderItemCsInquiryListExcelDownload = () => {
    const { getOrderItemCsInquiryListExcelDownload, orderDetail } = this.props;
    const { orderItemId } = orderDetail.orderInfo;
    const { filterOption, sortOption } = orderDetail.inquiryInfo;

    getOrderItemCsInquiryListExcelDownload({
      orderItemId,
      filterOption,
      sortOption,
    });
  };

  /**
   *  상품 문의 리스트 가져오기
   */
  getOrderItemCsQnaList = (data) => {
    const { getOrderItemCsQnaList, orderDetail } = this.props;
    const { orderItemId } = orderDetail.orderInfo;
    const { filterOption, sortOption, pagination } = orderDetail.inquiryInfo;

    getOrderItemCsQnaList({
      orderItemId,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   *  상품 문의 리스트 엑셀 다운로드
   */
  getOrderItemCsQnaListExcelDownload = () => {
    const { getOrderItemCsQnaListExcelDownload, orderDetail } = this.props;
    const { orderItemId } = orderDetail.orderInfo;
    const { filterOption, sortOption } = orderDetail.qnaInfo;

    getOrderItemCsQnaListExcelDownload({
      orderItemId,
      filterOption,
      sortOption,
    });
  };

  render() {
    const { orderDetail, getPreparationOrderReturnRequest, insertOrderItemCsMemoRequest, editOrderItemCsMemoRequest } =
      this.props;

    return (
      <OrderDetailWrap
        orderDetail={orderDetail}
        requestExchangeReturn={this.requestExchangeReturn}
        getOrderItemCsInquiryList={this.getOrderItemCsInquiryList}
        getOrderItemCsInquiryListExcelDownload={this.getOrderItemCsInquiryListExcelDownload}
        getOrderItemCsQnaList={this.getOrderItemCsQnaList}
        getOrderItemCsQnaListExcelDownload={this.getOrderItemCsQnaListExcelDownload}
        getPreparationOrderReturnRequest={getPreparationOrderReturnRequest}
        insertOrderItemCsMemoRequest={insertOrderItemCsMemoRequest}
        editOrderItemCsMemoRequest={editOrderItemCsMemoRequest}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orderDetail: state.order.orderDetail,
  };
};

const mapDispatchToProps = {
  getOrderDetailList: orderActions.getOrderDetailList,
  toggleModal: orderActions.toggleModal,
  getPreparationOrderReturnRequest: orderActions.getPreparationOrderReturnRequest,
  insertOrderItemCsMemoRequest: orderActions.insertOrderItemCsMemoRequest,
  editOrderItemCsMemoRequest: orderActions.editOrderItemCsMemoRequest,
  getOrderItemCsInquiryList: orderActions.getOrderItemCsInquiryList,
  getOrderItemCsInquiryListExcelDownload: orderActions.getOrderItemCsInquiryListExcelDownload,
  getOrderItemCsQnaList: orderActions.getOrderItemCsQnaList,
  getOrderItemCsQnaListExcelDownload: orderActions.getOrderItemCsQnaListExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderDetailContainer));
